import { Stack, Alert, VStack, HStack, Text } from "native-base";

export interface AlertProps {
  status: "success" | "error" | "warning" | "info";
  message: string;
  variant?: string;
  messageHtml?: boolean;
  coresPWA?: any;
}

export default function Alerta({
  status,
  message,
  variant,
  messageHtml,
  coresPWA,
}: Readonly<AlertProps>) {
  return (
    <Stack
      space={3}
      w="100%"
      padding={2}
      backgroundColor={coresPWA?.corFundoStack || coresPWA?.corFundo || null}
    >
      <Alert
        w="100%"
        variant={variant || "top-accent"}
        backgroundColor={coresPWA?.corFundo || null}
        status={status}
        borderColor={coresPWA?.corBordaPrimaria || null}
        borderWidth={1}
      >
        <VStack
          space={2}
          flexShrink={1}
          w="100%"
          backgroundColor={coresPWA?.corFundo || null}
        >
          <HStack
            flexShrink={1}
            space={2}
            justifyContent="space-between"
            backgroundColor={coresPWA?.corFundo || null}
          >
            <HStack
              space={2}
              flexShrink={1}
              backgroundColor={coresPWA?.corFundo || null}
            >
              <Alert.Icon mt="1" />
              <Text
                fontSize="md"
                color={coresPWA?.corFontePrimaria || "coolGray.800"}
              >
                {messageHtml ? (
                  <div dangerouslySetInnerHTML={{ __html: message }} />
                ) : (
                  message
                )}
              </Text>
            </HStack>
          </HStack>
        </VStack>
      </Alert>
    </Stack>
  );
}
